export default __webpack_public_path__ + "static/media/Schwein-unter-Apfelbaum.b13d133f.png";